import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from 'react-apollo';

import withModal from '../../../../../../components/global/modal/withModal';
import Button from '../../../../../../components/global/Button';
import { getAsset } from '../../../../../../util/assets';
import useVirtualPageView from '../../../../../../apps/pro/services/analytics/useVirtualPageView';
import getAccountCardPromoCodesQuery from '../../../../graphql/queries/getAccountCardPromoCodes';
import ShareUrlIcons from '../../../../../../components/global/ShareUrlIcons';

const propTypes = {
  onComplete: PropTypes.func.isRequired,
  sharingEnabled: PropTypes.bool,
};

const AccountCardCheckoutSuccessAlert = ({ onComplete, sharingEnabled }) => {
  useVirtualPageView({
    title: 'Create a card - Success!',
    path: '/success',
  });

  const { data: { me: account } = {} } = useQuery(
    getAccountCardPromoCodesQuery,
    {
      fetchPolicy: 'network-only',
      skip: !sharingEnabled,
    },
  );

  const affiliateUrl = account?.affiliate_urls?.records?.[0];
  const promoCode = account?.promo_codes?.records?.[0];

  return (
    <div className="account-card-checkout-success-modal-body">
      <div className="account-card-checkout-success-modal-header">
        <img
          src={getAsset('/waldo-excited.png')}
          alt=""
          width="48"
          className="mb-1"
        />

        <h3 className="m-0 text-extra-bold">Thank you!</h3>
        <p className="text-bold">Your order is being fulfilled!</p>
      </div>

      {(affiliateUrl || promoCode) && (
        <div className="promo-code-cta">
          <h4 className="promo-code-cta-title">
            Refer friends and earn cards!
          </h4>

          {promoCode && (
            <p>
              Share your referral link or promo code:
              <span className="promo-code-cta-code">{promoCode.code}</span>
            </p>
          )}

          <p className="text-bold">
            Earn a <strong>FREE</strong> card for each friend who sends their
            first card. They&rsquo;ll get a FREE card too!
          </p>

          {affiliateUrl && (
            <ShareUrlIcons
              className="mt-2"
              url={affiliateUrl.url}
              quote="Hey! Follow this link to get a free card with your 1st one sent!"
              hashtag="#waldophotos"
            />
          )}
        </div>
      )}

      <div className="text-center mt-3">
        <Button
          btnStyle="link"
          onClick={onComplete}
          className="modal-link-dismiss"
        >
          Close this
        </Button>
      </div>
    </div>
  );
};

AccountCardCheckoutSuccessAlert.propTypes = propTypes;

export { AccountCardCheckoutSuccessAlert as AccountCardCheckoutSuccessAlertComponent };

export default withModal(AccountCardCheckoutSuccessAlert, {
  dismissible: false,
  hideHeader: true,
  size: 'sm',
  type: 'full',
  className: 'account-card-checkout-success-modal',
});
